import { render, staticRenderFns } from "./LoadMoreButton.vue?vue&type=template&id=4b5f6cbc&scoped=true"
import script from "./LoadMoreButton.vue?vue&type=script&lang=js"
export * from "./LoadMoreButton.vue?vue&type=script&lang=js"
import style0 from "./LoadMoreButton.vue?vue&type=style&index=0&id=4b5f6cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5f6cbc",
  null
  
)

export default component.exports